// removed by extract-text-webpack-plugin
module.exports = {"VenueFieldset":"_2IMjHGHGKT5q6wNm_odqQ2"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/VenueFieldset.scss
// module id = 1428
// module chunks = 0